import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiRoot } from "consts";
import { useDataQuery } from "hooks/useData";

const ONBOARDING_SEEN_PATH = "onboarding/seen/";

type OnboardingSeenResponse = {
  seenTopics: string[];
};

export function useOnboardingSeenTopics(): string[] {
  const data = useDataQuery<OnboardingSeenResponse>(ONBOARDING_SEEN_PATH);

  return data?.seenTopics ?? [];
}

export function useMarkOnboardingSeen() {
  const queryClient = useQueryClient();

  const mutation = useMutation<unknown, Error, string>({
    mutationFn: async (topic) => {
      const response = await fetch(`${apiRoot}${ONBOARDING_SEEN_PATH}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ topic }),
      });

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }

      return response.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [ONBOARDING_SEEN_PATH] });
    },
  });

  return mutation.mutate;
}
